import { Board } from '../board';
import { BoardSnapshot } from '../board-snapshot';
import { GameLogicDepth } from '../game-logic-depth';
import { CardDisclosureStatus, PileId } from '../logic-types';
import { Action } from './action';

export class DrawDeckAction implements Action {
  private board: Board;
  private gameLogicDepth: GameLogicDepth;
  private lastSnapshot: BoardSnapshot | undefined;
  private lastCardIndex: number | undefined;

  constructor(board: Board, gameLogicDepth: GameLogicDepth) {
    this.board = board;
    this.gameLogicDepth = gameLogicDepth;
  }

  public saveSnapshot(): void {
    this.lastSnapshot = this.board.boardSnapshot;
    this.board.boardSnapshot = new BoardSnapshot(
      this.lastSnapshot.foundations,
      this.lastSnapshot.tableaus,
      this.lastSnapshot.deck,
      this.lastSnapshot.waste,
    );
  }

  public execute(): void {
    this.saveSnapshot();

    const originPile = this.board.getPileByPileId(PileId.Deck);
    const targetPile = this.board.getPileByPileId(PileId.Waste);

    if (!this.board.deck.hasCards) {
      return;
    }

    const lastDeckCard = this.board.lastDeckCard();
    if (lastDeckCard === undefined) {
      return;
    }

    const card = this.board.getCardByCardIndex(lastDeckCard.index);
    if (card === undefined) {
      return;
    }

    originPile.removeCard(card);

    this.lastCardIndex = card.index;
    this.gameLogicDepth.updateCardDepth(card.index);

    targetPile.addCard(card);

    card.openCard();
    card.setStatusWhenNone(CardDisclosureStatus.Pending);
  }

  public undo(): void {
    if (this.lastCardIndex !== undefined) {
      this.gameLogicDepth.updateCardDepth(this.lastCardIndex);
    }
    if (this.lastSnapshot !== undefined) {
      this.board.boardSnapshot = this.lastSnapshot;
    }
  }
}
